module.exports = __webpack_public_path__ + "static/img/rank_background.b8f462e2.png";